import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import AppLayout from './layouts/AppLayout.jsx';
import CostingPage from './pages/CostingPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import EmployeesPage from './pages/EmployeesPage.jsx';
import EntityPage from './pages/EntityPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import OrdersPage from './pages/OrdersPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import StitcherScanPage from './pages/StitcherScanPage.jsx';
import { crudResources } from './config/crudResources.js';

export default function App() {
  const { user } = useAuth();
  if (!user) return <LoginPage />;
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="stitcher-scan" element={<StitcherScanPage />} />
        {Object.entries(crudResources)
          .filter(([resource]) => resource !== 'orders')
          .map(([resource, config]) =>
            <Route key={resource} path={resource} element={<EntityPage resource={resource} config={config} />} />)}
        <Route path="reports" element={<EntityPage title="Reports" description="Daily production output and department cost reporting" endpoint="/data/reports" />} />
        <Route path="costing" element={<CostingPage />} />
        <Route path="administration" element={<SettingsPage administration />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
